import { ssoHeaders } from "../../config/headers";
import Headers from "../../config/headers";
import LocalStorageFunc from "../../helpers/localStorageFunc";
import ApiCalls from "../../config/apiCalls";
import {
  LoginStates,
  LoginStateStatus,
} from "../../helpers/loginStateConstants";
import {
  projectBasePathWithFolder,
  clientPlatform,
} from "../../config/apiEndpoints";
import Utility from "../../helpers/utility";
import {
  updateAmplitudeUserProperties,
  EVENT_CLICK_SUBMITOTP,
  EVENT_AUTO_LOGIN_TRIGGERED,
  EVENT_OTP_GENERATION_SUCCESSFUL,
  EVENT_OTP_GENERATION_FAILED,
  EVENT_LOGIN_SUCCESSFUL,
  EVENT_LOGIN_FAILED,
} from "../../helpers/analyticsEvents";
import { ORDER_TYPE } from "../../helpers/OrderStatusConstants";
import {
  keyMapsMutation,
  keyMapsAction,
  keyMapsGetter,
} from "../../helpers/storeKeys";

export default {
  namespaced: true,
  state: {
    isLoggedIn: false,
    showWelcomeScreenOnPageLoad: clientPlatform == "Web" ? false : true,
    currentLoginState:
      clientPlatform == "Web"
        ? LoginStates.welcomeLogin
        : LoginStates.onboarding,
    loginStateStatus: "",
    isSessionPresent: LocalStorageFunc.accessToken(),
    cart_id: LocalStorageFunc.cartId(),
    showProfileDrawerModal: false,
    loginProps: {},
    loginError: "",
    mobileNo: LocalStorageFunc.getUserMobileNo(),
    isHamburger: LocalStorageFunc.isHamburger(),
  },
  getters: {},
  mutations: {
    updateLogginState(state, payload) {
      LocalStorageFunc.updateIsLoggedIn(payload);
      state.isLoggedIn = payload.isLoggedIn;
    },
    updateIsHamburger(state, payload) {
      state.isHamburger = payload;
      LocalStorageFunc.setIsHamburger(payload);
    },
    updateMobileNo(state, payload) {
      state.mobileNo = payload;
    },
    updateLoginProps(state, payload) {
      state.loginProps = payload;
    },
    updateShowProfileDrawerModal(state, payload) {
      state.showProfileDrawerModal = payload;
    },
    updateLoginError(state, payload) {
      state.loginError = payload;
    },
    createLocalStorageUserInfo(state, payload) {
      let value = {
        headers: {
          isLoggedIn: false,
          deliveryType:
            LocalStorageFunc.getDeliveryType() || ORDER_TYPE.DELIVERY,
          isSSO: true,
          credentials: payload.credentials,
          userId: payload.userId,
          cartId: payload.cartId,
        },
      };
      localStorage.userInfo = JSON.stringify(value);
      state.isLoggedIn = false;
    },
    // updateLocalStorageUserInfoCredential(state, payload) {
    //   let value = localStorage.userInfo
    //     ? Utility.tryJsonParse(localStorage.userInfo)
    //     : "";
    //   try {
    //     if (payload.sessionToken) {
    //       value.headers.credentials = {
    //         accessKeyId: payload.accessKeyId,
    //         secretKey: payload.secretKey,
    //         sessionToken: payload.sessionToken,
    //       };
    //     } else {
    //       value.headers.credentials = {
    //         accessKeyId: payload.accessToken,
    //         refreshToken: payload.refreshToken,
    //       };
    //     }
    //     localStorage.userInfo = JSON.stringify(value);
    //   } catch (e) {
    //     state.isLoggedIn = false;
    //   }
    // },
    updateLocalStorageUserInfo(state, payload) {
      let value = localStorage.userInfo
        ? Utility.tryJsonParse(localStorage.userInfo)
        : "";
      try {
        if (payload?.credentials) {
          value.headers.credentials = payload.credentials;
        }
        if (payload?.attributes?.userId) {
          value.headers.userId = payload.attributes.userId;
          updateAmplitudeUserProperties({ userId: payload.attributes.userId });
        } else if (payload?.userId) {
          value.headers.userId = payload.userId;
          updateAmplitudeUserProperties({ userId: payload.userId });
        }
        if (payload.attributes) {
          value.headers.cartId = payload.attributes.cartId;
          value.userData = payload.attributes;
          LocalStorageFunc.setAddressDetail(payload.attributes);
        }
        localStorage.userInfo = JSON.stringify(value);
      } catch (e) {
        state.isLoggedIn = false;
      }
    },
    updateLocalStorageUserData(state, payload) {
      let value = localStorage.userInfo
        ? Utility.tryJsonParse(localStorage.userInfo)
        : "";
      try {
        value.userData = payload;
        localStorage.userInfo = JSON.stringify(value);
      } catch (e) {
        state.isLoggedIn = false;
      }
    },
    updateIsSessionPresent(state, payload) {
      state.isSessionPresent = payload;
    },
    updateShowWelcomeScreenOnPgLoad(state, payload) {
      state.showWelcomeScreenOnPageLoad = payload;
    },
    updateCurrentLoginState(state, payload) {
      state.currentLoginState = payload;
    },
    updateLoginStateStatus(state, payload) {
      state.loginStateStatus = payload;
    },
    updateCartId(state, payload) {
      state.cartId = payload;
      LocalStorageFunc.setCartId(payload);
    },
  },
  actions: {
    anonymousUserApi({ commit, dispatch }, payload) {
      ApiCalls.ANONYNMOUS_USER_API({
        headers: Headers(),
      })
        .then(function (response) {
          if (response?.data?.status) {
            commit("createLocalStorageUserInfo", response.data);
            commit("updateCurrentLoginState", LoginStates.welcomeLogin);
            LocalStorageFunc.setComputedLocationData({});
            // dispatch("generateCartIdApi", {});
            LocalStorageFunc.unsetKey("userAddresses");
            if (payload.isLogout) {
              Utility.resetLocalStorageOnLogout();
            }
            if (typeof payload.startupApiCalls === "function") {
              payload.startupApiCalls();
            }
            if (payload.isLogout) {
              commit("updateLogginState", {
                isLoggedIn: false,
              });
              LocalStorageFunc.emptyCart();
              commit("updateIsSessionPresent", true);
              Utility.redirectToHomeOrRedirectUrl();
            }
          }
          commit("updateIsSessionPresent", true);
        })
        .catch(function (error) {
          commit("updateIsSessionPresent", true);
        });
    },
    forgotPasswordApi({ commit }, payload) {
      commit("updateLoginStateStatus", LoginStateStatus.SENDING_OTP);
      ApiCalls.FORGOT_PASSWORD_API({
        headers: Headers(),
        payload: payload,
      })
        .then(function (response) {
          if (response?.data?.status == "SUCCESS") {
            commit("updateCurrentLoginState", LoginStates.otpVerification);
            commit("updateLoginStateStatus", LoginStateStatus.SENT_OTP);
            commit("updateMobileNo", payload.mobile);
          }
          if (response?.response?.data?.status == "FAILED") {
            commit(
              "updateLoginStateStatus",
              LoginStateStatus.SENDING_OTP_FAILED
            );
            EVENT_OTP_GENERATION_FAILED({
              loginMethod: "manual",
            });
          } else {
            EVENT_OTP_GENERATION_SUCCESSFUL({
              loginMethod: "manual",
            });
          }
        })
        .catch(function (error) {
          commit("updateLoginStateStatus", LoginStateStatus.SENDING_OTP_FAILED);
        });
    },
    validateOtpCodeApi({ commit, dispatch }, payload) {
      const { code, mobile, screenName } = payload;
      commit("updateLoginStateStatus", LoginStateStatus.VALIDATING_OTP);
      ApiCalls.VALIDATE_OTP_CODE_API({
        headers: Headers(),
        payload: { code, mobile, screenName },
      })
        .then(function (response) {
          if (response?.data?.status == "SUCCESS") {
            Utility.resetLocalStorageOnLogin();
            commit(
              "updateLoginStateStatus",
              LoginStateStatus.VALIDATED_OTP_VALID
            );
            // reseting cart id
            commit("updateCartId", "");
            commit("updateLogginState", {
              isLoggedIn: true,
            });
            commit("updateLocalStorageUserInfo", response.data);
            if (payload.autologin) {
              EVENT_AUTO_LOGIN_TRIGGERED({
                subCategory: "Success",
              });
            } else {
              EVENT_CLICK_SUBMITOTP({
                subCategory: "Success",
                loginMethod: "manual",
              });
              EVENT_LOGIN_SUCCESSFUL({
                loginMethod: "manual",
              });
            }
            // dispatch("generateCartIdApi", {});
            Utility.redirectToHomeOrRedirectUrl();
          } else {
            commit(
              "updateLoginStateStatus",
              LoginStateStatus.VALIDATED_OTP_INVALID
            );
            if (payload.autologin) {
              EVENT_AUTO_LOGIN_TRIGGERED({
                subCategory: "Failure",
              });
            } else {
              EVENT_CLICK_SUBMITOTP({
                subCategory: "Failure",
                loginMethod: "manual",
              });
              EVENT_LOGIN_FAILED({
                loginMethod: "manual",
              });
            }
          }
        })
        .catch(function (error) {
          commit(
            "updateLoginStateStatus",
            LoginStateStatus.VALIDATED_OTP_INVALID
          );
          if (payload.autologin) {
            EVENT_AUTO_LOGIN_TRIGGERED({
              subCategory: "Failure",
            });
          } else {
            EVENT_CLICK_SUBMITOTP({
              subCategory: "Failure",
              loginMethod: "manual",
            });
            EVENT_LOGIN_FAILED({
              loginMethod: "manual",
            });
          }
        });
    },
    loadLoginStatus({ commit, dispatch }, payload) {
      commit("updateLogginState", {
        isLoggedIn: LocalStorageFunc.isLoggedIn() || false,
      });
    },
    logoutUserApi({ commit, dispatch }, payload) {
      ApiCalls.LOGOUT_USER_API({
        headers: Headers(),
        payload: {},
      })
        .then(function (response) {
          if (response?.data?.status) {
            commit("createLocalStorageUserInfo", "");
            Utility.resetLocalStorageOnLogout();
            commit("updateLogginState", {
              isLoggedIn: false,
            });
            LocalStorageFunc.emptyCart();
          }
          commit("updateIsSessionPresent", true);
          Utility.redirectToHomeOrRedirectUrl();
        })
        .catch(function (error) {
          commit("updateIsSessionPresent", true);
        });
    },
  },
};
